import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonService } from '@core/services/common.service';
import { PolicyService } from '@core/services/policy.service';
import { MaInsuranceCar } from '@shared/models/ma-insurance';
import { MaInsuranceUpdate } from '@shared/models/ma-insurance-update';

@Component({
    selector: 'app-ma-insurance-car',
    templateUrl: './ma-insurance-car.component.html',
    styleUrls: ['./ma-insurance-car.component.scss'],
    standalone: false
})
export class MaInsuranceCarComponent implements OnInit {
    @Input() maInsurance: MaInsuranceCar;
    @Input() showEdit: boolean;
    @Input() agentSource: number;
    @Input() policyNumber: string;

    public editMode: boolean = false;
    public form: FormGroup;

    constructor(
        private policyService: PolicyService,
        private commonService: CommonService
    ) {

    }

    ngOnInit(): void {
        this.form = new FormGroup({
            crn: new FormControl(this.maInsurance.vehicle.crn, [Validators.minLength(6)]),
            vic: new FormControl(this.maInsurance.vehicle.vic, [Validators.minLength(8)])
        });
    }

    editable() {
        if (this.agentSource == 1) {
            this.commonService.agentSourceMsg();
        } else {
            this.editMode = !this.editMode;
        }
    }

    submit($event) {

        if (this.agentSource == 1) {
            return;
        }

        let maInsuranceUpdate = new MaInsuranceUpdate();

        maInsuranceUpdate.policyNumber = this.policyNumber;
        maInsuranceUpdate.crn = this.form.value.crn;
        maInsuranceUpdate.vic = this.form.value.vic;
        maInsuranceUpdate.errors = {};
        maInsuranceUpdate.out_of_time = false;

        this.policyService.setMaInsurance(maInsuranceUpdate).subscribe(result => {
            if (result.out_of_time == true) {
                this.editMode = false;
                this.commonService.openEditPopUpModal('vehicle');
                return;
            }

            if (Object.entries(result.errors).length > 0) {
                for (const [key, value] of Object.entries(result.errors)) {
                    let err = {};
                    err[value] = true;
                    this.form.get(key).setErrors(err);
                }

            } else {
                window.location.reload();
            }
        });
    }
}
